// extracted by mini-css-extract-plugin
export default {"root":"MobileSearchPage__root--3Fr2O","root_error":"MobileSearchPage__root_error--21SKd","content":"MobileSearchPage__content--1nEUG"};